import { useCallback, useState } from 'react'

export const useTabs = () => {
  const [tabIndex, setTabIndex] = useState<number>(0)

  const handleTabChange = useCallback((_event: any, newValue: number) => {
    setTabIndex(newValue)
  }, [])

  return [tabIndex, handleTabChange] as const
}
